import { ajaxApiNew, ajaxApi, fileDownloadApiNew, downloadApi, axiosPost } from '@/server'
import common from '@/public/common'
import { getCookieNew } from '@/public/utils'

/** 新来货单接口统一前缀：SapUrl = http://sap-t.vsigo.cn/scs/ */
 //const deliveryPrefix = common.scpUrl + 'delivery'

const deliveryPrefix = 'http://192.168.10.8:8404/delivery-open'

/** 老接口前缀（change-stack） */
const urlLink = common.scpUrl + 'change-stack'

/** 统一获取供应商编码，所有接口共用 */
const getSupplierCode = () => getCookieNew('supplier_code') || null

// ==================== 列表 ====================

/** 1. 分页查询来货单列表 */
export const fetchDeliveryList = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/query-list',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 查询来货单枚举字典（状态/仓库/生成方式等筛选选项） */
export const fetchDeliveryDictionary = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/query-dictionary',
    params: { service: 'scs', ...params, supplier_code: getSupplierCode() }
  })
}

// ==================== 详情 ====================

/** 2. 查询来货单明细 */
export const fetchDeliveryDetail = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/query-detail',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 3. 查询来货单物流轨迹信息 */
export const fetchLogisticsTrace = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/query-logistics-trace',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 4. 修改来货单预计到货日期 */
export const updateDeliveryExpectDate = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/update-delivery-expect-date',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

// ==================== 新增 / 导入 ====================

/** 5. 人工新增来货单并校验 */
export const manualCreateDelivery = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/manual-create',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 6. 上传发货详情（导入来货单，is_bond=1 走保税仓） */
export const importDelivery = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/import-delivery',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

// ==================== 导出 ====================

/** 8. 导出来货单待发货明细 */
export const exportDelivery = (param, filename) => {
  return fileDownloadApiNew({
    url: deliveryPrefix + '/export',
    param: { ...param, supplier_code: getSupplierCode() },
    filename
  })
}

/** 9. 导出保税仓来货单待发货明细 */
export const exportBondDelivery = (param, filename) => {
  return fileDownloadApiNew({
    url: deliveryPrefix + '/export-bond-delivery',
    param: { ...param, supplier_code: getSupplierCode() },
    filename
  })
}

/** 导出随货同行单（批量） */
export const exportBatchDelivery = (param, filename) => {
  return fileDownloadApiNew({
    url: deliveryPrefix + '/export-batch-delivery',
    param: { ...param, supplier_code: getSupplierCode() },
    filename
  })
}

/** 查询随货同行单批量导出/打印数据 */
export const fetchBatchDeliveryExcel = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/query-batch-delivery-excel',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 14. 按发货单号导出来货单明细 */
export const exportDeliveryByCode = (param, filename) => {
  return fileDownloadApiNew({
    url: deliveryPrefix + '/export',
    param: { ...param, supplier_code: getSupplierCode() },
    filename
  })
}

// ==================== 取消 ====================

/** 10. 取消来货单 */
export const cancelDelivery = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/cancel-delivery',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

// ==================== 附件管理 ====================

/** 11. 上传来货单附件 */
export const uploadAnnex = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/upload-annex',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 12. 删除来货单附件 */
export const deleteAnnex = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/delete-annex',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

/** 13. 查询来货单附件列表 */
export const fetchAnnexList = (params) => {
  return ajaxApiNew({
    url: deliveryPrefix + '/query-annex',
    params: { ...params, supplier_code: getSupplierCode() }
  })
}

// ==================== 文件上传（第三方七牛） ====================

/** 获取上传token */
export const fetchUploadToken = (fileNames) => {
  return axiosPost(`${common.scpUrl}/file/upload/token/get`, fileNames)
}

/** 上传文件到七牛（第三方，不加supplier_code） */
export const uploadToQiniu = (form) => {
  return axiosPost('https://upload.qiniup.com/', form)
}

// ==================== 老接口（暂保留，新接口就绪后替换） ====================

/** 获取发货单状态字典（老接口） */
export const fetchDeliveryStatus = () => {
  return ajaxApi({
    url: urlLink + '/Supplier',
    params: {
      action: 'getdictionarybytypekey',
      data: { TypeKey: 'DeliveryStatus', supplier_code: getSupplierCode() }
    }
  })
}

/** 获取仓库列表（老接口） */
export const fetchWarehouseList = () => {
  return ajaxApi({
    url: urlLink + '/WareHouse',
    params: { action: 'getwarehouseforsale', supplier_code: getSupplierCode() }
  })
}

/** 根据订单编号查询订单状态（老接口，跳转详情用） */
export const fetchPurchaseForSupplier = (data) => {
  return ajaxApi({
    url: urlLink + '/Purchase',
    params: { pageIndex: 1, pageSize: 15, action: 'getpurchaseforsupplierlist', data: { ...data, supplier_code: getSupplierCode() } }
  })
}

/** 下载UDI附件导入模板（老接口，详情页用） */
export const downloadUdiTemplateNew = () => {
  return fileDownloadApiNew({
    url: common.escmProUrl + 'supplier-delivery/download-udi-annex-template',
    param: { supplier_code: getSupplierCode() },
    filename: 'UDI附件导入模板.xlsx'
  })
}



// WEBPACK FOOTER //
// ./src/pages/deliverGoodsNew/service.js